module.exports = __webpack_public_path__ + "img/banner_img.0dc0b8c9.jpg";